
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { SectionWrapper } from 'resources/styles/CommonStyles';
import { Button, Row } from 'saladsoft-primitive';

import { SellerDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import styled from 'styled-components';
import moment from 'moment';
import { TableHeaderRow, TableRow } from 'resources/styles/CommonTableStyles';

const BusinessInfoCleansingModal = ({ row }: { row: SellerDto }) => {
  const { t } = useTranslation();
  const { uiStore } = useStoreWrapper();

  const [seller, setSeller] = useState<SellerDto | null>(null);
  const [nextId, setNextId] = useState<string | null>(null);
  const [previousId, setPreviousId] = useState<string | null>(null);

  const fetchSeller = (id: number) => {
    setSeller(null);
    setNextId(null);
    setPreviousId(null);
    ServiceHelper.sellerService?.getSeller(id, { isUnMatch: true }).then((res) => {
      if (res.status === 200) {
        // 대소문자 구분 없이 헤더 키 찾기
        const nextId =
          res.headers['x-next-id'] || res.headers['X-Next-Id'] || res.headers['X-NEXT-ID'];
        const previousId =
          res.headers['x-previous-id'] ||
          res.headers['X-Previous-Id'] ||
          res.headers['X-PREVIOUS-ID'];

        setSeller(res.data);
        setNextId(nextId);
        setPreviousId(previousId);
      } else {
        toast.error(t('Failed to fetch seller'));
      }
    });
  };

  useEffect(() => {
    if (row.id) {
      fetchSeller(row.id);
    }
  }, [row]);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        uiStore?.modal.close();
      }
    };

    document.addEventListener('keydown', handleEscKey, true);

    return () => {
      document.removeEventListener('keydown', handleEscKey, true);
    };
  }, [uiStore]);

  return (
    <TitleCleansingModalWrapper className="crawler-section-wrapper">
      <Row
        width="100%"
        justifyContent="space-between"
        gap="40px"
        alignItems="flex-start"
        marginTop={40}
      >
        <div style={{ flex: 0.6 }}>
          <SectionWrapper style={{ marginBottom: 20 }}>
            <div>{t('seller.sellerName')}</div>
            <div>{seller?.sellerName || '-'}</div>
          </SectionWrapper>
          <Row justifyContent="flex-start" alignItems="center" flexWrap="wrap">
            <Row gap={20} alignItems="flex-start">
              <SectionWrapper style={{ marginBottom: 20 }}>
                <div>{t('seller.receiveDate')}</div>
                <div>{moment(seller?.receiveDate).format('YYYY-MM-DD HH:mm:ss') || '-'}</div>
              </SectionWrapper>
              <SectionWrapper style={{ marginBottom: 20 }}>
                <div>{t('Modified At')}</div>
                <div>{moment(seller?.modifyDate).format('YYYY-MM-DD HH:mm:ss') || '-'}</div>
              </SectionWrapper>
            </Row>
          </Row>
          <div style={{ fontSize: 12, color: '#0032e4', marginTop: 30 }}>{t('notice')}</div>

          {/* <>{orderCleansing?.customsTitle}</> */}
        </div>
        <div style={{ flex: 0.4 }}>
          <Row gap="10px" justifyContent="flex-start" marginBottom="20px">
            <Button
              isValid={!!(previousId && previousId !== 'null' && previousId !== 'undefined')}
              onClick={() => previousId && previousId !== 'null' && previousId !== 'undefined' && fetchSeller(Number(previousId))}
            >
              {t('Previous')}
            </Button>
            <Button 
              isValid={!!(nextId && nextId !== 'null' && nextId !== 'undefined')} 
              onClick={() => nextId && nextId !== 'null' && nextId !== 'undefined' && fetchSeller(Number(nextId))}
            >
              {t('Next')}
            </Button>
          </Row>
        </div>
      </Row>
      <div>
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <TableHeaderRow>
              <th style={{ width: '10%', borderBottom: '2px solid #414141' }}>{t('fields')}</th>
              <th style={{ width: '45%', borderBottom: '2px solid #414141' }}>{t('RAW DATA')}</th>
              <th style={{ width: '45%', borderBottom: '2px solid #414141' }}>{t('Q10')}</th>
            </TableHeaderRow>
          </thead>
          <tbody>
            <TableRow>
              <td>{t('seller.businessName')}</td>
              <td>{seller?.businessName}</td>
              <td>{seller?.crawlBusinessName ?? '-'}</td>
            </TableRow>
            <TableRow>
              <td>{t('seller.postalCode')}</td>
              <td>{seller?.postalCode}</td>
              <td>-</td>
              {/* <td>{seller?.crawlPostalCode ?? '-'}</td> */}
            </TableRow>
            <TableRow>
              <td>{t('seller.address')}</td>
              <td>{seller?.address}</td>
              <td>{seller?.crawlAddress ?? '-'}</td>
            </TableRow>
            <TableRow>
              <td>{t('seller.phoneNumber')}</td>
              <td>{seller?.phoneNumber}</td>
              <td>{seller?.crawlPhoneNumber ?? '-'}</td>
            </TableRow>
          </tbody>
        </table>
      </div>
    </TitleCleansingModalWrapper>
  );
};

const TitleCleansingModalWrapper = styled.div`
  width: 100%;
  padding: 0 40px;
`;

export default BusinessInfoCleansingModal;
